// @flow
import * as React from 'react';
import type { SvgComponentProps } from '~/core/icons/svg-icons/types';

const Thunderstorms = ({ fill, svgComponents: { G, Path } }: SvgComponentProps) => {
    const gProps = fill ? { fill } : {};
    return (
        <G {...gProps}>
            <Path d="M26.73,30.87H23.64v-1h3.09a6.23,6.23,0,1,0-3.86-11.11l-.49.39-.27-.57a7.91,7.91,0,1,0-8.87,11.1l-.22,1a8.91,8.91,0,1,1,9.72-13,7.23,7.23,0,1,1,4,13.25Z" />
            <Path d="M11.58,33.45a.5.5,0,0,1-.43-.75l4.36-7.4a.5.5,0,0,1,.86.51L12,33.21A.5.5,0,0,1,11.58,33.45Z" />
            <Path d="M22.06,33.45a.5.5,0,0,1-.43-.75L26,25.3a.5.5,0,1,1,.86.51l-4.36,7.4A.5.5,0,0,1,22.06,33.45Z" />
            <Path d="M17.27,36a.5.5,0,0,1-.43-.75l2.57-4.36H16.78a.5.5,0,0,1-.43-.75l2.79-4.81a.5.5,0,1,1,.87.5l-2.35,4.06h2.64a.5.5,0,0,1,.43.75l-3,5.12A.5.5,0,0,1,17.27,36Z" />
        </G>
    );
};

export default Thunderstorms;



// WEBPACK FOOTER //
// ./src/core/icons/svg-icons/weather/thunderstorms/index.js